import { render, staticRenderFns } from "./PersonnelRecordDetailsTabChronicle.vue?vue&type=template&id=a0a68756"
import script from "./PersonnelRecordDetailsTabChronicle.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabChronicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports